export default __webpack_public_path__ + "static/media/pamelas.4996246c.jpeg";